import { render } from "./profile.vue?vue&type=template&id=4a7b03c4"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"

import "./profile.vue?vue&type=style&index=0&id=4a7b03c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__